import branchEditComponent from './branch.edit.component';

let branchEditModule = angular.module('branchedit', [
])

.component('branchedit', branchEditComponent)

.name;

export default branchEditModule;


// WEBPACK FOOTER //
// ./client/app/components/branch/edit/index.js